import { useParams } from "react-router";
import { RefActivity } from "../../../../api/hooks";
import ActivityView from "../../../../common/activity/ActivityView";

const StockAdjustmentActivity = () => {
    const { stockAdjustmentId } = useParams<any>();
    return (
        <div>
            {stockAdjustmentId && (
                <ActivityView
                    className="mt-3 border"
                    activityRef={RefActivity?.ProductStockAdjustment}
                    activityRefId={stockAdjustmentId ?? ""}
                />
            )}
        </div>
    );
};

export default StockAdjustmentActivity;
